var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity_box"},[_vm._v(" 模板三 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }